import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from './Components/FrontPages/Home/Home';
import NotFound from './Components/CommonPages/NotFound/NotFound';
import Contact from './Components/FrontPages/Contact/Contact';
import Blog from './Components/FrontPages/Blog/Blog';
import About from './Components/FrontPages/About/About';
import Portfolio from './Components/FrontPages/Portfolio/Portfolio';
import Navbar from './Components/CommonPages/Navbar/Navbar';
import Footers from './Components/CommonPages/Footer/Footers';
import Layout from 'antd/lib/layout/layout';

function App() {
  return (
    <Layout>

      <Router>
        <Navbar />

        <Switch>

          <Route exact path="/" component={Home} />
          <Route path="/Portfolio" component={Portfolio} />
          <Route path="/About" component={About} />
          <Route path="/Blog" component={Blog} />
          <Route path="/Contact" component={Contact} />
          <Route path="*" component={NotFound} />
          
        </Switch>

        <Footers />
      </Router>

    </Layout>
  );
}

export default App;
